import * as v from "valibot";

// request schema
export const RequestSchema = v.object({
  ClusterId: v.string(),
  Name: v.string(),
  ReleaseName: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const ResponseSchema = v.object({
  Data: v.boolean(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
